module.exports = __webpack_public_path__ + "img/4.08f255a6.png";